import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useCompaniesErrorsStore = defineStore(
  'insights-companies-errors',
  () => {
    const error = ref<string | null>(null)
    const runStartFailed = ref(false)
    const retries = ref(0)

    function setError(value: string): void {
      error.value = value
    }

    function setRunStartFailed(value: string): void {
      error.value = value
      runStartFailed.value = true
    }

    function incrementRetries(): void {
      retries.value = retries.value + 1
    }

    function reset(): void {
      error.value = null
      runStartFailed.value = false
      retries.value = 0
    }

    return {
      error,
      runStartFailed,
      retries,
      setError,
      setRunStartFailed,
      incrementRetries,
      reset,
    }
  }
)
